export const PayeeType = {
  INDIVIDUAL: 'Individual',
  COMPANY: 'Company',
};

export const PayeeCreationTypes = {
  ...PayeeType,
  CSV_UPLOAD: 'CSV_UPLOAD',
};
